import './index.scss'

interface iconProps {
  iconUrl: string
  activeIconUrl?: string
  className?: string
  width?: string
  height?: string
  marginRight?: string
  style?: object
}

/**
 * @param iconUrl svg图片的URL资源地址
 * @param className
 * @param width
 * @param height
 * @param marginRight
 * @param style
 * @returns
 */
const ImgSvgIcon = (props: iconProps) => {
  const {
    className = '',
    iconUrl,
    activeIconUrl,
    width = '24px',
    height = '24px',
    marginRight = '5px',
    style = {},
  } = props

  return (
    <span
      className={`cxfe-crm-img-svg-icon ${className}`}
      style={{
        display: 'inline-block',
        width,
        height,
        marginRight,
        backgroundImage: `url(${iconUrl}), url(${activeIconUrl})`,
        overflow: 'hidden',
        ...style,
      }}
    />
  )
}

export default ImgSvgIcon
